import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentApiRepository } from '../repositories/document-api.repository';
import { DocumentInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class DocumentProvider {
    constructor(private documentApiRepository: DocumentApiRepository) {}

    detail(document: DocumentInterface): Observable<Transaction<any>> {
        return this.documentApiRepository.detail(document);
    }

    remove(document: DocumentInterface): Observable<Transaction<void>> {
        return this.documentApiRepository.remove(document);
    }
}
